import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"

interface Props {
  className?: string
}

export function CloseIcon(props: Props) {
  const { _ } = useLingui()

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Frame">
        <title>{_(msg`Close Icon`)}</title>
        <path
          id="Vector"
          d="M13 1L1 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M1 1L13 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
